export const supportedLanguageCodes = ['pt', 'en', 'es', 'zh'] as const;

export type SupportedLanguageCode = (typeof supportedLanguageCodes)[number];

/** @deprecated Prefer SupportedLanguageCode */
export type PublicAuthLanguageCode = SupportedLanguageCode;

export interface LanguageOption {
  code: SupportedLanguageCode;
  label: string;
  flag: string;
}

export const languageOptions: readonly LanguageOption[] = [
  {code: 'pt', label: 'Português', flag: '🇧🇷'},
  {code: 'en', label: 'English', flag: '🇺🇸'},
  {code: 'es', label: 'Español', flag: '🇪🇸'},
  {code: 'zh', label: '中文', flag: '🇨🇳'},
] as const;

export function isSupportedLanguage(
  lang: string,
): lang is SupportedLanguageCode {
  return (supportedLanguageCodes as readonly string[]).includes(lang);
}

export function resolveLanguage(
  stored: string | null,
  browserLang: string,
  fallback: SupportedLanguageCode = 'pt',
): SupportedLanguageCode {
  if (stored && isSupportedLanguage(stored)) {
    return stored;
  }
  if (isSupportedLanguage(browserLang)) {
    return browserLang;
  }
  return fallback;
}
